import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useUsageStore = create()(
  persist(
    (set, get) => ({
      conversions: 0,
      isWebPro: false,
      isLifetime: false,
      
      incrementConversions: () => set((state) => ({ 
        conversions: state.conversions + 1 
      })),
      
      setWebPro: (status) => set({ isWebPro: status }),
      setLifetime: (status) => set({ isLifetime: status, isWebPro: true }),
      
      isPremium: () => {
        const state = get();
        return state.isWebPro || state.isLifetime;
      },
      
      shouldShowAds: () => {
        const state = get();
        return state.conversions > 5 && !state.isPremium();
      },
      
      canBatchConvert: (fileCount) => {
        const state = get();
        if (state.isPremium()) return true;
        return fileCount <= 3;
      }
    }),
    {
      name: 'usage-storage',
    }
  )
)
